import React from 'react';

import {
  EXP_DESTINATION_EXPANDED_BETA,
  EXP_DESTINATION_EXPANDED_BETA_VARIANTS,
} from 'constants/featureFlag';
import { getFlagValueForUser } from 'utilities/featureFlag';

import { useFlagIsActivated } from 'hooks/featureFlag';

export default function useDestination(): boolean | null {
  return useFlagIsActivated({
    flag: EXP_DESTINATION_EXPANDED_BETA,
    activationValues: EXP_DESTINATION_EXPANDED_BETA_VARIANTS,
    skipLoggingToSegment: false,
  });
}

export function DestinationOnly({
  children,
}: {
  children: React.ReactNode;
}): React.ReactNode {
  const hasDestination = useDestination();

  return hasDestination ? children : null;
}

export function userHasDestination(): Promise<boolean> {
  return new Promise(resolve => {
    getFlagValueForUser(EXP_DESTINATION_EXPANDED_BETA).then(result => {
      resolve(EXP_DESTINATION_EXPANDED_BETA_VARIANTS.includes(result));
    });
  });
}
